import { render, staticRenderFns } from "./PostcodeDeleteDialog.vue?vue&type=template&id=a59aec06&scoped=true"
import script from "./PostcodeDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./PostcodeDeleteDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59aec06",
  null
  
)

export default component.exports